<template>
  <notes 
    @updated="handleInput" 
    ref="notes"
    :notes="input"
    :parent="parent"
    :readonly="readonly"
  />
</template>

<script>
import field from "../../Mixins/field";
import Notes from "../Messages/Notes/Notes";

export default {
  props: ['parent'],
  mixins: [field],
  components: { Notes },
  methods: {
    validate() {
      return this.$refs.notes.validate();
    }
  }
};
</script>